var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',{attrs:{"label":_vm.colConfig.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('el-progress',{attrs:{"text-inside":true,"stroke-width":18,"percentage":parseFloat(row[_vm.colConfig.prop]) < 0 ? 0.0: parseFloat(row[_vm.colConfig.prop]),"status":"success"}})],1)}}])})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3909f3db","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/KnowledgeGraph/_components/AccuracyColumn.vue
// module id = null
// module chunks = 